import styled from "styled-components";
import { IText } from "./Text.interface";
import { sm } from "../../../AppTheme.styled";

const textSizes = {
  caption: 12,
  small: 14,
  medium: 16,
  large: 18,
};

const StyledText = styled.p<IText>`
  font-size: ${(props) => (props.size ? textSizes[props.size] - 2 : 14)}px;
  font-weight: 400;
  text-align: ${({ textAlign }) => textAlign || "inherit"};
  line-height: 160%;
  color: ${(props) =>
    props.color ? props.theme.palette[props.color] : "#000000"};
  margin: ${({ spacing }) => (spacing ? `${8 * spacing}px 0` : "0")};
  word-break: break-word;

  ${sm} {
    font-size: ${(props) => (props.size ? textSizes[props.size] : 16)}px;
  }
`;

export default StyledText;
